<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii">
<p class="dedi">‘Our dreams have jurisdiction only over ourselves’ Bunny Jingadangelow</p>
<p class="dedi1">For David and Sue, with love</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedi.vue?17856084